function oxgStatusBarCloseButtons(buttons) {
  let statusBar = document.getElementById('oxg-status-bar')
  Array.from(buttons).forEach(button => {
    let id = button.getAttribute('data-sb-msg-id')
    let messageContainer = statusBar.querySelector('div[data-sb-msg-id="' + id + '"]')
    button.addEventListener('click', (e)=> {
      e.preventDefault()
      closeStatusBarMessage(messageContainer)
    })
  })
}

function closeStatusBarMessage(messageContainer) {
  let height = messageContainer.offsetHeight
  messageContainer.style.height = height + 'px'
  messageContainer.style.transition = 'all 0.2s ease-out'
  setTimeout(()=> {
    messageContainer.style.height = 0;
    messageContainer.style.opacity = 0;
    messageContainer.style.pointerEvents = 'none';
  }, 15)
  setTimeout(()=> {
    messageContainer.remove()
  }, 215)
  let url = new URL(window.location)
  let searchParams = new URLSearchParams(url.search)
  searchParams.delete('msg');
  searchParams.delete('msg_type');
  searchParams.delete('msg_auto_close');
  searchParams.delete('msg_prevent_close');
  let newUrl = url.pathname + '?' + searchParams.toString();
  window.history.replaceState({}, '', newUrl);
}

document.addEventListener('DOMContentLoaded', ()=> {
  let statusBarCloseButtons = document.querySelectorAll('.oxg-close-status-bar-message')
  if(statusBarCloseButtons) {
    oxgStatusBarCloseButtons(statusBarCloseButtons)
  }
})